import { useState } from "react";

import { allMetrics } from "app/components/widget/widget-config/metrics/metricsRegistry";
import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { AddToDashboardModalV2 } from "pro-features/components/Modals/src/AddToDashboardModal-v2";

import type { IAddToDashboardProps } from "./AddToDashboard";
import { useGetCustomModel } from "./AddToDashboard";

export const useAddToDashboard = (props: Omit<IAddToDashboardProps, "buttonProps">) => {
    const customModel = useGetCustomModel(props);
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => {
        if (customModel?.metric) {
            const metricConfig = allMetrics[customModel.metric];
            allTrackers.trackEvent(
                "Pop up",
                "open",
                `Add to my Dashboard/${i18nFilter()((metricConfig?.properties?.title as string) || "")}`,
            );
        }
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const modalElement = isOpen ? (
        <AddToDashboardModalV2
            customModel={customModel}
            onConfirm={closeModal}
            onCancel={closeModal}
        />
    ) : null;

    return { openModal, modalElement };
};
